import {
    Box,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Grid,
    MenuItem,
    TextField,
    Typography,
    Avatar,
    InputAdornment,
    Select,
    Paper,
    IconButton,
  } from "@mui/material";
  import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { IAccountCreateRequest } from "../../store/interfaces/IAccount";
import { useCreateAccountImageMutation, useCreateAccountMutation } from "../../store/api";
import { SnackbarKey, useSnackbar } from "notistack";
import { HighlightOff, ContentCopy, Close } from "@mui/icons-material";
import { PHONE_PREFIXES } from "../../constants/phonePrefixes";
  


  const initialState: IAccountCreateRequest = {
    name: "",
    email: "",
    logo: "",
    owner: true,
    url: "",
    primaryColor: "#000000",
    secondaryColor: "#FFD700",
    socialMediaList: [
      { name: "instagram", username: "" },
      { name: "supportWhatsapp", username: "" },
    ],
    sendEmailConf: {
      gmail: "soporte@viprifas.com",
      gpass: "re_HPAbLtJM_3kJnDECQG3nUJkq5UZmAhVXG",
    },
    sorter: {
      name: "Cuenta",
      lastname: "Admin",
      email: "",
      status: "ACTIVE",
      password: "",
      profile: "admin",
      accountId: "",
    },
  };
  
  interface AccountFormProps {
    open: boolean;
    setOpenDialog: Dispatch<SetStateAction<boolean>>;
  }

  export const AccountForm = ({open, setOpenDialog}: AccountFormProps) => {


    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const handleSnackbarClose = (key: SnackbarKey) => {
        closeSnackbar(key);
    };


        function showToast(message: string, variant: string) {
    if (variant !== "success" && variant !== "warning" && variant !== "error") {
      return;
    }
    enqueueSnackbar(message, {
      action: (key) => {
        return (
          <HighlightOff
            sx={{ cursor: "pointer" }}
            onClick={() => handleSnackbarClose(key)}
          />
        );
      },
      variant: variant,
      anchorOrigin: {
        horizontal: "right",
        vertical: "top",
      },
    });
  }



    const phonePrefixes = PHONE_PREFIXES;

    // Extraer prefijo y número del valor inicial de WhatsApp si existe
    const getInitialWhatsappData = () => {
      const whatsappSocial = initialState.socialMediaList.find(s => s.name === 'supportWhatsapp');
      if (whatsappSocial?.username) {
        const prefix = phonePrefixes.find(p => whatsappSocial.username.startsWith(p.code));
        if (prefix) {
          return {
            prefix: prefix.code,
            number: whatsappSocial.username.replace(prefix.code, ''),
          };
        }
      }
      return { prefix: "+58", number: "" };
    };

    const initialWhatsapp = getInitialWhatsappData();

    const [formData, setFormData] = useState(initialState);
    const [logoPreview, setLogoPreview] = useState<string | null>(null);
    const [logoFile, setLogoFile] = useState<File | null>(null);
    const [openInfoDialog, setOpenInfoDialog] = useState(false);
    const [whatsappPrefix, setWhatsappPrefix] = useState(initialWhatsapp.prefix);
    const [whatsappNumber, setWhatsappNumber] = useState(initialWhatsapp.number);
    const [createAccount, {data: createAccountResponse}] = useCreateAccountMutation();
    const [createAccountImage, {data: createAccountImageResponse}] = useCreateAccountImageMutation();


    
    useEffect(() => {
        if (createAccountResponse && logoFile) {
            createAccountImage({
                accountId: formData.sorter.accountId,
                imageFile: logoFile,
                imageName: `${formData.sorter.accountId}.png`,
            }).then((response) => {
                showToast('Imagen creada', 'success'); 
              }).catch((error) => {
                showToast('Hubo un error al crear la imagen', 'error'); 
              });
        }
    }, [createAccountResponse])

    useEffect(() => {
      if (createAccountImageResponse) {
          setOpenDialog(false);
          setOpenInfoDialog(true);
          window.open(formData.url, '_blank');
      }

    }, [createAccountImageResponse])

    const getAccountInfo = () => {
      return `URL Inicio de venta: ${formData.url}

URL Inicio de sesión: ${formData.url}/login

Credenciales inicio de sesión: 
Usuario: ${formData.sorter.email}
Contraseña: ${formData.sorter.password}`;
    };

    const handleCopyToClipboard = () => {
      const info = getAccountInfo();
      navigator.clipboard.writeText(info).then(() => {
        showToast('Información copiada al portapapeles', 'success');
      }).catch(() => {
        showToast('Error al copiar la información', 'error');
      });
    };

    const handleCloseInfoDialog = () => {
      setOpenInfoDialog(false);
    };
  
    const generateAccountId = (name: string): string => {
      return name
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '') // Remover caracteres especiales
        .replace(/[\s_]+/g, '-') // Reemplazar espacios y guiones bajos con guiones
        .replace(/-+/g, '-') // Reemplazar múltiples guiones con uno solo
        .replace(/^(?:-)+|(?:-)+$/g, ''); // Remover guiones al inicio y final
    };

    const handleChange = (field: string, value: any) => {
      setFormData((prev) => {
        const updated = {
          ...prev,
          [field]: value,
        };
        
        // Si cambia el nombre, generar automáticamente el accountId
        if (field === 'name' && value) {
          updated.sorter = {
            ...prev.sorter,
            accountId: generateAccountId(value),
          };
        }
        
        // Si cambia el email del account, sincronizar con el email del sorter
        if (field === 'email') {
          updated.sorter = {
            ...prev.sorter,
            email: value,
          };
        }
        
        return updated;
      });
    };

    const handlePasswordChange = (value: string) => {
      setFormData((prev) => ({
        ...prev,
        sorter: {
          ...prev.sorter,
          password: value,
        },
      }));
    };
  
    const handleSocialChange = (index: number, value: string) => {
      const newSocialList = [...formData.socialMediaList];
      const social = newSocialList[index];
      
      // Si es WhatsApp, actualizar el número local y combinar con prefijo
      if (social.name === 'supportWhatsapp') {
        setWhatsappNumber(value);
        newSocialList[index].username = whatsappPrefix + value;
      } else {
        newSocialList[index].username = value;
      }
      
      setFormData((prev) => ({
        ...prev,
        socialMediaList: newSocialList,
      }));
    };

    const handleWhatsappPrefixChange = (prefix: string) => {
      setWhatsappPrefix(prefix);
      // Actualizar el valor en socialMediaList combinando prefijo + número
      const newSocialList = [...formData.socialMediaList];
      const whatsappIndex = newSocialList.findIndex(s => s.name === 'supportWhatsapp');
      if (whatsappIndex !== -1) {
        newSocialList[whatsappIndex].username = prefix + whatsappNumber;
        setFormData((prev) => ({
          ...prev,
          socialMediaList: newSocialList,
        }));
      }
    };
  
    const handleLogoUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0];
      if (file) {
        setLogoFile(file)
        setLogoPreview(URL.createObjectURL(file));
      }
    };
  
    const handleSubmit = () => {
        createAccount({...formData, logo: `${formData.sorter.accountId}.png`})
    };
  
    return (
      <>
      <Dialog
        open={open}
        onClose={() => setOpenDialog(false)}
        maxWidth="lg"
        fullWidth
        scroll="body"
        PaperProps={{
          sx: {
            borderRadius: 3,
            maxHeight: '90vh',
          }
        }}
      >
        <DialogTitle sx={{ pb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <Box>
            <Typography variant="h5" fontWeight="bold" gutterBottom>
              Crear Nueva Cuenta
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Completa la información para crear una nueva cuenta
            </Typography>
          </Box>
          <IconButton
            onClick={() => setOpenDialog(false)}
            size="small"
            sx={{ mt: -1, mr: -1 }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ p: 0 }}>
          <Box sx={{ p: 4 }}>
            <Box component="form" noValidate autoComplete="off">
              <Grid container spacing={3}>
                

{/* Fila 2: Logo y Branding y Redes Sociales */}
<Grid item xs={12} md={12}>
                  <Paper elevation={0} sx={{ p: 3, height: '100%', borderRadius: 2 }}>
                    <Typography variant="h6" fontWeight="600" gutterBottom sx={{ mb: 3 }}>
                      Logo y Branding
                    </Typography>
                    <Grid container spacing={3} alignItems="center">
                      <Grid item xs={6}>
                        <Button 
                          variant="outlined" 
                          component="label" 
                          fullWidth
                          size="large"
                          sx={{ 
                            py: 2,
                            borderStyle: 'dashed',
                            borderWidth: 2,
                            '&:hover': {
                              borderStyle: 'dashed',
                              borderWidth: 2,
                            }
                          }}
                        >
                          <Box sx={{ textAlign: 'center', width: '100%' }}>
                            <Typography variant="body1" fontWeight="medium">
                              {logoPreview ? 'Cambiar Logo' : 'Subir Logo'}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                              PNG, JPG o SVG (máx. 5MB)
                            </Typography>
                          </Box>
                          <input
                            type="file"
                            hidden
                            accept="image/*"
                            onChange={handleLogoUpload}
                          />
                        </Button>
                        {formData.logo && (
                          <Typography mt={1} variant="body2" color="success.main">
                            ✓ {formData.logo}
                          </Typography>
                        )}
                      </Grid>
                      <Grid item xs={6}>
                        {logoPreview ? (
                          <Box 
                            display="flex" 
                            justifyContent="center" 
                            alignItems="center"
                            sx={{ 
                              p: 3,
                              bgcolor: 'background.paper',
                              borderRadius: 2,
                              border: '1px solid',
                              borderColor: 'divider'
                            }}
                          >
                            <Avatar
                              src={logoPreview}
                              alt="Vista Previa del Logo"
                              sx={{ width: 120, height: 120 }}
                              variant="rounded"
                            />
                          </Box>
                        ) : (
                          <Box 
                            display="flex" 
                            justifyContent="center" 
                            alignItems="center"
                            sx={{ 
                              p: 3,
                              bgcolor: 'background.paper',
                              borderRadius: 2,
                              border: '1px dashed',
                              borderColor: 'divider',
                              minHeight: 150
                            }}
                          >
                            <Typography variant="body2" color="text.secondary">
                              Vista previa del logo
                            </Typography>
                          </Box>
                        )}
                      </Grid>
                    </Grid>
                  </Paper>
                </Grid>


                {/* Fila 1: Información Principal y Credenciales */}
                <Grid item xs={12} md={6}>
                  <Paper elevation={0} sx={{ p: 3, height: '100%', borderRadius: 2 }}>
                    <Typography variant="h6" fontWeight="600" gutterBottom sx={{ mb: 3 }}>
                      Información Principal
                    </Typography>
                    <Grid container spacing={3}>
                      <Grid item xs={6}>
                        <TextField
                          label="Nombre de la Cuenta"
                          fullWidth
                          required
                          value={formData.name}
                          onChange={(e) => handleChange("name", e.target.value)}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          label="URL del Sitio Web"
                          fullWidth
                          required
                          value={formData.url}
                          onChange={(e) => handleChange("url", e.target.value)}
                          placeholder="https://ejemplo.com"
                          helperText="URL donde estará disponible la cuenta"
                        />
                      </Grid>
                    </Grid>
                  </Paper>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Paper elevation={0} sx={{ p: 3, height: '100%', borderRadius: 2 }}>
                    <Typography variant="h6" fontWeight="600" gutterBottom sx={{ mb: 3 }}>
                      Credenciales de Acceso
                    </Typography>
                    <Grid container spacing={3}>
                      <Grid item xs={6}>
                        <TextField
                          label="Correo Electrónico"
                          type="email"
                          fullWidth
                          required
                          value={formData.email}
                          onChange={(e) => handleChange("email", e.target.value)}
                          helperText="Se usará también para el organizador"
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          label="Contraseña"
                          type="password"
                          fullWidth
                          required
                          value={formData.sorter.password}
                          onChange={(e) => handlePasswordChange(e.target.value)}
                          helperText="Se usará también para el organizador"
                        />
                      </Grid>
                    </Grid>
                  </Paper>
                </Grid>

                
                <Grid item xs={12} md={6}>
                  <Paper elevation={0} sx={{ p: 3, height: '100%', borderRadius: 2 }}>
                    <Typography variant="h6" fontWeight="600" gutterBottom sx={{ mb: 3 }}>
                      Redes Sociales
                    </Typography>
                    <Grid container spacing={3}>
                      {formData.socialMediaList.map((social, index) => {
                        const getSocialLabel = (name: string) => {
                          const labels: { [key: string]: string } = {
                            instagram: "Instagram",
                            supportWhatsapp: "Soporte WhatsApp",
                          };
                          return labels[name] || name;
                        };
                        
                        if (social.name === 'supportWhatsapp') {
                          return (
                            <Grid item xs={6} key={social.name}>
                              <TextField
                                label={getSocialLabel(social.name)}
                                fullWidth
                                value={whatsappNumber}
                                onChange={(e) => handleSocialChange(index, e.target.value)}
                                placeholder="Número de WhatsApp"
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <Select
                                        value={whatsappPrefix}
                                        onChange={(e) => handleWhatsappPrefixChange(e.target.value)}
                                        variant="standard"
                                        disableUnderline
                                        renderValue={(value) => {
                                          const selected = phonePrefixes.find(p => p.code === value);
                                          return (
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                              <span style={{ fontSize: '18px' }}>{selected?.flag}</span>
                                              <span>{selected?.code}</span>
                                            </Box>
                                          );
                                        }}
                                        sx={{
                                          '& .MuiSelect-select': {
                                            padding: '4px 8px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '6px',
                                            minWidth: '70px',
                                          },
                                          '& .MuiSelect-icon': {
                                            right: '4px',
                                          },
                                        }}
                                      >
                                        {phonePrefixes.map((prefix) => (
                                          <MenuItem key={prefix.code} value={prefix.code}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                              <span style={{ fontSize: '18px' }}>{prefix.flag}</span>
                                              <span>{prefix.code}</span>
                                              <Typography variant="caption" sx={{ ml: 1, color: 'text.secondary' }}>
                                                {prefix.country}
                                              </Typography>
                                            </Box>
                                          </MenuItem>
                                        ))}
                                      </Select>
                                      <Box
                                        sx={{
                                          width: '1px',
                                          height: '24px',
                                          bgcolor: 'divider',
                                          mx: 1,
                                        }}
                                      />
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </Grid>
                          );
                        }
                        
                        return (
                          <Grid item xs={6} key={social.name}>
                            <TextField
                              label={getSocialLabel(social.name)}
                              fullWidth
                              value={social.username}
                              onChange={(e) => handleSocialChange(index, e.target.value)}
                              placeholder={`@${getSocialLabel(social.name).toLowerCase()}`}
                            />
                          </Grid>
                        );
                      })}
                    </Grid>
                  </Paper>
                </Grid>

                {/* Fila 3: Configuración de Correo */}
                <Grid item xs={6}>
                  <Paper elevation={0} sx={{ p: 3, borderRadius: 2 }}>
                    <Typography variant="h6" fontWeight="600" gutterBottom sx={{ mb: 3 }}>
                      Configuración de Envío de Correo
                    </Typography>
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={6}>
                        <TextField
                          label="Gmail"
                          fullWidth
                          disabled
                          value={formData.sendEmailConf.gmail}
                          helperText="Valor constante"
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <TextField
                          label="Contraseña de Gmail"
                          type="password"
                          fullWidth
                          disabled
                          value={formData.sendEmailConf.gpass}
                          helperText="Valor constante"
                        />
                      </Grid>
                    </Grid>
                  </Paper>
                </Grid>

              </Grid>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 3, pt: 2 }}>
          <Button
            variant="outlined"
            onClick={() => setOpenDialog(false)}
            size="large"
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            size="large"
            sx={{ 
              fontWeight: "bold",
              px: 4,
              minWidth: 200
            }}
          >
            Crear Cuenta
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openInfoDialog} onClose={handleCloseInfoDialog} maxWidth="md" fullWidth>
        <DialogTitle>
          <Typography variant="h6" fontWeight="bold">
            Cuenta Creada Exitosamente
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2 }}>
            <Typography variant="body1" gutterBottom>
              <strong>URL Inicio de venta:</strong> {formData.url}
            </Typography>
            <Typography variant="body1" gutterBottom sx={{ mt: 2 }}>
              <strong>URL Inicio de sesión:</strong> {formData.url}/login
            </Typography>
            <Typography variant="body1" gutterBottom sx={{ mt: 2 }}>
              <strong>Credenciales inicio de sesión:</strong>
            </Typography>
            <Box sx={{ ml: 2, mt: 1 }}>
              <Typography variant="body2">
                <strong>Usuario:</strong> {formData.sorter.email}
              </Typography>
              <Typography variant="body2" sx={{ mt: 1 }}>
                <strong>Contraseña:</strong> {formData.sorter.password}
              </Typography>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseInfoDialog} color="secondary">
            Cerrar
          </Button>
          <Button
            onClick={handleCopyToClipboard}
            variant="contained"
            startIcon={<ContentCopy />}
            color="primary"
          >
            Copiar Información
          </Button>
        </DialogActions>
      </Dialog>
    </>
    );
  };
  